import React, { useRef } from "react";
import { Icon, chakra, useMultiStyleConfig } from "@chakra-ui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useButton } from "react-aria";
export default function ClearSelectButton({ isDisabled, onClick, }) {
    const ref = useRef(null);
    const { buttonProps } = useButton({
        isDisabled,
        children: "Clear selection",
        elementType: "span",
        onPress: onClick,
    }, ref);
    const styles = useMultiStyleConfig("ClearSelectButton");
    return (React.createElement(chakra.span, { ref: ref, __css: styles["button"], "data-testid": "select-clear", ...buttonProps },
        React.createElement(Icon, { as: XMarkIcon, __css: styles["icon"] })));
}
